import React, { useState, useEffect } from "react";
import './CancelAppointment.css'
import {
    GetAppointment,
    GetServices,
    GetBarbers,
    CancelAppointmentCall,
    GetShopId
} from './Requests';
import {PulseLoader } from "react-spinners";
const daysOfWeek = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thur',
    'Fri',
    'Sat'
  ]

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dev'
  ]

  const CancelAppointment = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const appointmentIdFromUrlParam = queryParameters.get("appointment")
    const [appointmentId, setAppointmentId] = useState(appointmentIdFromUrlParam)
    const [appointment, setAppointment] = useState()
    const [isLoading, setIsLoading] = useState(true);
    const [appointmentFound, setAppointmentFound] = useState(false);
    const [barberName, setBarberName] = useState()
    const [serviceName, setServiceName] = useState()
    const [date, setDate] = useState()
    const [time, setTime] = useState()
    const [cancelledClicked, setCancelledClicked] = useState(false)
    const [shopId, setShopId] = useState()
    const [cancelledSuccessful, setCancelledSuccessful] = useState()

    useEffect(() => {
        GetAppointmentWrapper()
      }, []);

      function GetAppointmentWrapper()
      {
        GetAppointment(appointmentId).then((res) => {
            if (res.data !== '')
            {
                setAppointment(res.data)
                setDate(daysOfWeek[new Date(res.data.startDateTime).getDay()]+ " " + new Date(res.data.startDateTime).getDate() + " " + months[new Date(res.data.startDateTime).getMonth()])
                setTime(new Date(res.data.startDateTime).getHours()+ ":" + (new Date(res.data.startDateTime).getMinutes() === 0 ? "00" : new Date(res.data.startDateTime).getMinutes()))
                GetBarbersWrapper(res.data)
                // GetShopIdWkarapper(res.data)
                setShopId(res.data.shopId)
                setIsLoading(false)
                setAppointmentFound(true)
            }
            else
            {
                setAppointmentFound(false)
                setIsLoading(false)
            }
        }).catch((error) => {
            setAppointmentFound(false)
            setIsLoading(false)
        })
      }

      function GetBarbersWrapper(appointmentVar)
      {
        // GetBarbers().then((res) => {
        //     setBarberName(res.data.filter(x => x.barberId === appointmentVar.barberId)[0].name)
        //     GetServicesWrapper(appointmentVar)
        // }).catch((error) => {
        // })
      }

      function GetServicesWrapper(appointmentVar)
      {
        // GetServices(appointmentId).then((res) => {
        //     setServiceName(res.data.filter(x => x.serviceId === appointmentVar.serviceId)[0].name)
        //     GetShopIdWarapper()
        // }).catch((error) => {
        // })
      }

    //   function GetShopIdWarapper()
    //   {
    //     GetShopId().then((res) => {
    //         setShopId(res.data)
    //         setIsLoading(false)
    //         setAppointmentFound(true)
    //     }).catch((error) => {
    //     })
    //   }

      function CancelButtonClicked()
      {
        setCancelledClicked(true)
        setIsLoading(true)
        setAppointmentFound(false)
        CancelAppointmentCall(appointment.eventId, 0, "Customer", shopId).then((res) => {
            if (res.status === 200)
            {
                setIsLoading(false)
                setCancelledSuccessful(true)
            }
        }).catch((error) => {
            setIsLoading(false)
            setCancelledSuccessful(false)
        })
      }

    return (
    <div className="cancel-appointment-container">
        <div className="cancel-appointment-card">
                <PulseLoader 
                color={'#333'}
                loading={isLoading}
                size={25}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
            {!isLoading && !cancelledClicked ?
                appointmentFound ?

            <div>
                <h1>Cancel Appointment</h1>
                <p>
                    You're about to cancel your <strong>{serviceName}</strong> appointment with <strong>{barberName}</strong> on <strong>{date}</strong> at <strong>{time}</strong>.
                </p>
                <p>Are you sure you want to cancel this appointment?</p>
                <button onClick={CancelButtonClicked}>Yes, Cancel Appointment</button>
            </div>
            :
            <div>
                <h1>Oh no!</h1>
                <p>
                    We can not locate your appointment. Please try again or contact us to cancel your appointment
                </p>
            </div>
            :
            <></>}

            {!isLoading && cancelledClicked && cancelledSuccessful?
            <div>
                        <div className="icon-wrapper">
          <span className="check-icon">&#10003;</span>
        </div>
            <h1>Appointment Cancelled</h1>
            <p>Your appointment has been canceled.</p>
            <a href={process.env.REACT_APP_CLIENT_BASE_URL+"make-a-booking?id="+shopId}><button>Book Another Appointment</button></a>
        </div>
            :
            <></>
        }

        {!isLoading && cancelledClicked && !cancelledSuccessful?
            <div>
            <div className="icon-problem-wrapper">
            <span className="problem-icon">&#x2718;</span>
            </div>
            <h1>Problem</h1>
            <p>There was an issue cancelling your appointment. Please try again or contact us to cancel your appointment</p>
            </div> 
            :
            <></>
        }

        </div>
    </div>
    );
  };
  
  export default CancelAppointment;